import 'css-chunksrc/client/scenes/weekTimeRecords/row/styles.scss';export default {
  "row": "_row_3unvc_1",
  "text": "_text_3unvc_10",
  "resourceTask": "_resourceTask_3unvc_15",
  "avatar": "_avatar_3unvc_23",
  "names": "_names_3unvc_29",
  "projectName": "_projectName_3unvc_34",
  "timeSpentForm": "_timeSpentForm_3unvc_39",
  "timeSpentInput": "_timeSpentInput_3unvc_47",
  "unit": "_unit_3unvc_53",
  "resourceName": "_resourceName_3unvc_59",
  "taskName": "_taskName_3unvc_68",
  "project": "_project_3unvc_34",
  "zoneAvatar": "_zoneAvatar_3unvc_81",
  "timeSpent": "_timeSpent_3unvc_39",
  "validation": "_validation_3unvc_94",
  "validated": "_validated_3unvc_103",
  "actions": "_actions_3unvc_107",
  "action": "_action_3unvc_107",
  "remove": "_remove_3unvc_128",
  "icon": "_icon_3unvc_136"
};